module.exports = __webpack_public_path__ + "static/img/cpjfwzx_bg.3659d70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cpjfwzx_bg.png
// module id = HWfC
// module chunks = 21